import React, { Component } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';


import { homeRoute, componentRoutes, docRoutes } from '../routeConfig';
import Sidebar from '../components/Sidebar';
import ScrollResetter from '../components/ScrollResetter';
import Routes from '../components/Routes';

import '@styles/index.css';

class App extends Component {
  render() {
    const groups = [...componentRoutes, ...docRoutes, homeRoute];

    return (
      <Router>
        <ScrollResetter>
          <main className="app flex">
            <Sidebar componentRoutes={componentRoutes} docRoutes={docRoutes}/>
            <div className="main-wrapper">
              {groups.map((group, i) =>
                <Routes key={`sub-route-${i}`} group={group} />
              )}
            </div>
          </main>
        </ScrollResetter>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js